import {useQuery} from "@tanstack/react-query";

import {permanentParkingService} from "../services";

export function usePermanentParkingPermit(permitId: number | null) {
  const {data, isSuccess, isPending, isError, error, isFetching, refetch} = useQuery({
    queryKey: ["permanentparkingpermit", permitId],
    queryFn: () => permanentParkingService.getPermit(permitId!),
    enabled: permitId != null && permitId > 0,
    retry: false,
    refetchOnWindowFocus: true,
    refetchOnMount: "always",
  });

  return {
    permit: isSuccess && data ? data : null,
    isSuccess,
    isPending,
    isError,
    error,
    isFetching,
    refetch,
  };
}
